$(document).ready( function(){
  function setInitialStateFromUrl() {
    var urlParams = new URLSearchParams(window.location.search);
    var sortByParam = urlParams.get('sort_by');

    if (sortByParam) {
      $('.collection-filter__sort--dropdown li').each( function() {        
        if ($(this).attr('value') === sortByParam) {
          $('#SortBy').val(sortByParam);
          $('.sort-button').find('span').text($(this).text())
        }
      })
    }
  }
  setInitialStateFromUrl();
  
  $('body').on('click','.sort-button', function() {
    $('.collection-filter__sort--dropdown').toggleClass('open');
  })

  $('body').on('click','.collection-filter__sort--dropdown li', function() {
    var selectElement = document.getElementById('SortBy');
    var $this = this;
    var liValue = $(this).attr('value');
    

    var urlParams = new URLSearchParams(window.location.search);
    
    urlParams.set('sort_by', liValue);
    window.history.replaceState({}, '', window.location.pathname + '?' + urlParams.toString());

    if(liValue){
      $('#SortBy').val(liValue);
      $('.sort-button').find('span').text($($this).text());
      var event = new Event('change');
      selectElement.dispatchEvent(event);
    }else{
      var liValue = $($this).attr('value');
      $('#SortBy').val(liValue);
      var event = new Event('change');
      selectElement.dispatchEvent(event);
    }

    $('.collection-filter__sort--dropdown').removeClass('open');
  })


  $(".menu_level_1 > li > .slide-nav__button").click(function () {
    var $this = $(this);
    $this.next(".slide-nav__dropdown").slideToggle();
    $this.parent(".slide-nav__item").toggleClass("is_active");
  
    $(".menu_level_2 .slide-nav__dropdown").hide();
    $(".menu_level_2 .slide-nav__item").removeClass("is_active");

    console.log('123');
  });
  $(".menu_level_2 > li > .slide-nav__button").click(function () {
    var $this = $(this);
    $this.next(".slide-nav__dropdown").slideToggle();
    $this.parent(".slide-nav__item").toggleClass("is_active");
  });
});